/**
 * Abschnitt Varianten — Preisebenen, Gewicht und Grundpreis je Variante.
 * Entfernen = aktiv=false beim Speichern (nie löschen).
 */
import { Layers, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Section } from './EditorPrimitives';
import VariantRowCard from './VariantRowCard';

export default function ProductEditorVarianten({ form, product, setRow, addRow, removeRow, errorFields, loading }) {
  const rows = form.rows.filter((r) => !r._removed);
  const linked = !!product?.shopify_product_id;

  const handleRemove = (row) => {
    if (row.id && !window.confirm(`Variante „${row.title || row.sku || '—'}“ deaktivieren? Bestand und Historie bleiben erhalten.`)) return;
    removeRow(row._key);
  };

  return (
    <Section icon={Layers} title={`Varianten${rows.length > 1 ? ` (${rows.length})` : ''}`}
      hint={linked
        ? 'SKU, Online-/Streichpreis, Gewicht und Grundpreis werden beim Speichern nach Shopify übertragen. B2B-Preise bleiben privat.'
        : 'Nicht in Shopify — Änderungen gelten nur in FieldConnect.'}
      action={(
        <Button type="button" variant="outline" size="sm" onClick={addRow} className="h-9 gap-1.5 shrink-0">
          <Plus className="w-3.5 h-3.5" /> Variante
        </Button>
      )}>
      {loading ? (
        <p className="text-sm text-slate-400 py-4 text-center">Varianten werden geladen…</p>
      ) : rows.length === 0 ? (
        <p className={`text-sm py-4 text-center rounded-lg border border-dashed ${errorFields.has('rows') ? 'border-red-300 text-red-600' : 'border-slate-300 text-slate-400'}`}>
          Keine aktive Variante — bitte eine anlegen.
        </p>
      ) : (
        <div className="space-y-3">
          {rows.map((row, i) => (
            <VariantRowCard
              key={row._key}
              row={row}
              index={i}
              productPreis={form.product.preis}
              linked={linked}
              onChange={(patch) => setRow(row._key, patch)}
              onRemove={() => handleRemove(row)}
              canRemove={rows.length > 1}
            />
          ))}
        </div>
      )}
    </Section>
  );
}
